import LayoutAuth from '@common/LayoutAuth'
import { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import s from './index.module.css'
import common from '../common.module.css'
import { SetTitlePage } from '@common/SetTitlePage'
import { Button, Form, Input, Modal, Radio } from 'antd'
import classNames from 'classnames'
import { settingApi, usersAPI, smsIntegrationApi } from "@/api";
import { Link } from 'react-router-dom'
import { SETTINGS_TYPES } from '@/constant'
import { AuthService } from '@/services/AuthService'
import jwt_decode from 'jwt-decode';
import { jsonConvert } from '@/helpers/jsonConvert'
import { sortingArray } from '@/helpers/sortingArray'
import { useAddAlert } from '@/hooks/useAddAlert'
import Preloader from '@UI/Preloader'

const RestorePassword = () => {
  const addAlert = useAddAlert();

  const hist = useHistory()
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState({})
  const [form] = Form.useForm()
  const [isFormValid, setIsFormValid] = useState(false)
  const [restoreMethod, setRestoreMethod] = useState('email') // 'email' или 'phone'
  const [codeDeliveryMethod, setCodeDeliveryMethod] = useState('') // 'sms' или 'telegram'
  const [token, setToken] = useState('');

  const [settings, setSettings] = useState(null);
  const ordersForConfirmation = !!settings?.ordersForConfirmation?.length ? jsonConvert(settings?.ordersForConfirmation) : [];
  
  const getSettings = () => {
      settingApi.getAll()
        .then(response => {
            const items = response.data.filter(item => item.type === SETTINGS_TYPES.GENERAL);
            const generalSettings = {};
            items.forEach(item => Object.assign(generalSettings, { [item.key]: item.value }));
            setSettings(generalSettings);
        });
  }
  useEffect(() => {
    getSettings()
  }, []);

  const onFieldsChange = () => {
    try {
      const values = form.getFieldsValue()
      const errors = form.getFieldsError()
      
      // Проверяем что:
      // 1. Поле заполнено в зависимости от выбранного метода
      // 2. Нет ошибок валидации
      const isValid = 
        (restoreMethod === 'email' ? values.email : values.phone) &&
        errors.every((field) => !field.errors.length)
        
      setIsFormValid(!!isValid)
    } catch (e) {
      setIsFormValid(false)
    }
  }

  const getValueFrom = (e) => {
    const name = e.target.id
    setError(prev => ({ ...prev, [name]: null }))
  }

  const confirmationByPhoneNumber = settings?.confirmationByPhoneNumber == 1;
  const confirmationByTelegram = settings?.confirmationByTelegram == 1;

  const smsIntegrationEnabled = (settings?.sms_integration_enabled == 1) && ( confirmationByPhoneNumber || confirmationByTelegram )

  const getToken = smsIntegrationEnabled && !token && restoreMethod === 'phone';
  const restorePassword = async (data) => {
    if(settings === null) return;
 
    setLoading(true)
    // Отправляем нужные данные в зависимости от выбранного метода
    const requestData = restoreMethod === 'email' ?
      { email: data.email } 
      : getToken ? { 
          phone: data.phone,
          type: [codeDeliveryMethod],
          sendType: 'restore-password'
      } : { 
          phone: data.phone,
          token,
          code: data.code
      }
    const api = getToken ? smsIntegrationApi.getToken : usersAPI.restorePassword

    const result = await api(requestData)
    setLoading(false)
    if (result?.data?.status === 'success') {
      if(restoreMethod === 'email'){
          Modal.success({
              autoFocusButton: null,
              centered: true,
              afterClose: () => hist.push('/auth'),
              title: 'Восстановление пароля',
              content: 'На вашу электронную почту направлено письмо с новым паролем'
          })
      }
      else{
        if(getToken){
          setToken(result?.data?.token)
          addAlert({title: 'Код отправлен', text: 'Заполните поле с кодом подтверждения'})
        }
        else if(smsIntegrationEnabled){
          Modal.success({
              autoFocusButton: null,
              centered: true,
              afterClose: () => {
                const tokenDecode = jwt_decode(result?.data?.data?.user_token);
                console.log(tokenDecode)
                AuthService.auth({...tokenDecode, roles: [tokenDecode.role], id: tokenDecode.uid}, result?.data?.data?.user_token, result.data?.data?.refresh_token)
              },
              title: result?.data?.data?.message,
              content: 'Ваш пароль изменен на код подтверждения, вы можете изменить его в личном кабинете'
          })
        }
      }
    } else {
      Modal.error({
        autoFocusButton: null,
        centered: true,
        title: 'Восстановление пароля',
        content: Array.isArray(result?.response?.data?.error) ? result?.response?.data?.error?.[0] : result?.response?.data?.error,
      })
    }
  }

  const onFinish = (data) => restorePassword(data)

  const [confirmationCheckboxes, setConfirmationCheckboxes] = useState([]);
  useEffect(()=>{
    if(settings === null) return;
    const newData = sortingArray([
      ...(confirmationByPhoneNumber ? [{key:'sms', label:'Смс', order: ordersForConfirmation?.findIndex(el=>el=='confirmationByPhoneNumber')}] : []),
      ...(confirmationByTelegram ? [{key: 'telegram', label: 'Telegram', order: ordersForConfirmation?.findIndex(el=>el=='confirmationByTelegram')}] : []),
    ], 'order');

    if(!newData?.length) return;

    setCodeDeliveryMethod(newData?.[0]?.key)
    setConfirmationCheckboxes(newData)
  }, [settings])

  return (
    <LayoutAuth>
      <SetTitlePage title='Восстановление пароля' />

      {
        settings === null ? (
          <Preloader /> 
        ) : (
          <div className={classNames(common.card, s.card)}>
            <h2 className={common.title}>Восстановление пароля</h2>
            {
              confirmationCheckboxes?.length > 1 && restoreMethod === 'phone' && (
                <span className={common.text}>На выбранный сервис придет временный пароль</span>
              )
            }
            
            <Form 
              form={form}
              className={common.form} 
              onFinish={onFinish}
              onFieldsChange={onFieldsChange}
              layout="vertical"
            >
              {
                smsIntegrationEnabled && !token && (
                  <Form.Item className={common.formItemRadio} style={{marginBottom:0}} name="restoreMethod" initialValue="email">
                    <Radio.Group 
                      onChange={(e) => setRestoreMethod(e.target.value)}
                      disabled={loading}
                    >
                      <Radio value="email">По email</Radio>
                      <Radio value="phone">По телефону</Radio>
                    </Radio.Group>
                  </Form.Item>
                )
              }

              {restoreMethod === 'email' ? (
                <Form.Item 
                  name='email' 
                  rules={[
                    { required: true, message: !smsIntegrationEnabled ? 'Пожалуйста, введите e-mail или номер телефона' : 'Пожалуйста, введите e-mail' },

                    ...(!smsIntegrationEnabled ? [{ type: 'email', message: 'Введите верный e-mail' }] : [])
                  ]}
                  {...error?.email}
                >
                  <Input 
                    className={common.input} 
                    placeholder={!smsIntegrationEnabled ? 'Электронная почта или номер телефона' : 'Электронная почта'} 
                    disabled={loading} 
                  />
                </Form.Item>
              ) : (
                <>
                  <Form.Item 
                    className={common.formItem}
                    name='phone' 
                    rules={[
                      { required: true, message: 'Пожалуйста, введите номер телефона' },
                      // Можно добавить валидацию для телефона
                      // { pattern: /регулярное выражение для телефона/, message: 'Введите верный номер телефона' }
                    ]}
                    {...error?.phone}
                    
                  >
                    <Input 
                      className={common.input} 
                      placeholder='Номер телефона' 
                      disabled={loading} 
                    />
                  </Form.Item>
                  {
                    getToken && <span className={classNames(common.text, common.textRed)}>
                      {confirmationCheckboxes?.length > 1 &&  'Выберите, куда отправить вам временный код для подтверждения'}
                      {confirmationCheckboxes?.length == 1 && (confirmationByPhoneNumber) && 'Временный код для подтверждения будет отправлен по смс'}
                      {confirmationCheckboxes?.length == 1 && (confirmationByTelegram) && 'Временный код для подтверждения будет отправлен в телеграм'}
                    </span>
                  }
                  {
                    getToken && confirmationCheckboxes?.length > 1 && (
                      <Form.Item className={classNames(common.formItem, common.formItemRadio)}>
                        <Radio.Group 
                          value={codeDeliveryMethod}
                          onChange={(e) => setCodeDeliveryMethod(e.target.value)}
                          disabled={loading}
                        > 
                          {
                            confirmationCheckboxes.map((el)=>{
                              return(
                                <Radio value={el.key}>{el.label}</Radio>
                              )
                            })
                          }
                        </Radio.Group>
                      </Form.Item>   
                    )
                  }
                </>
              )}
              {
                !!token && (
                  <Form.Item 
                    name='code' 
                    rules={[
                      { required: true, message: 'Пожалуйста, введите код подтверждения' }
                    ]}
                    {...error?.email}
                  >
                    <Input 
                      className={classNames(common.input, s.input)} 
                      placeholder='Код подтверждения' 
                      disabled={loading} 
                    />
                  </Form.Item>
                )
              }

              {error.status && (
                <Form.Item>
                  <div className="ant-form-item-explain-error">{error.text}</div>
                </Form.Item>
              )}

              <Form.Item>
                <div className={common.buttons}>
                  <Button 
                    htmlType="submit" 
                    className={classNames(
                      common.btnSubmit,
                      { [common.active]: isFormValid }
                    )}
                    loading={loading}
                  >
                    Восстановить
                  </Button>
                </div>
              </Form.Item>

              <div>
                <Link to='/auth' className={common.link}>Авторизация</Link>
              </div>
            </Form>
          </div>
        )
      }
    </LayoutAuth>
  )
}

export default RestorePassword